module.exports = __webpack_public_path__ + "static/media/cross-black.86cc322b.svg";